<template>
  <div>
    <div class="my-2">
      <div class="row">
        <div class="col-12">
          <input
            v-model="textFilter"
            type="search"
            class="form-control"
            :placeholder="$t('sectorSelectionModal.axtar')"
          >
        </div>
      </div>
    </div>

    <div style="max-height: 70vh; min-height: 60vh; margin-bottom: 40px; overflow-y: auto">
      <div
        v-if="textFilter===''"
        class="list-group"
      >
        <SectorSelectionSectorItem
          v-for="s in sectorMap"
          :key="s.id"
          :sector="s"
          :max-selection="maxSelection"
          :selected-ids="selectedIds"
          :selected-parent-ids="selectedParentIds"
          @selected="sectorSelected($event)"
          @removed="sectorRemoved($event)"
        />
      </div>
      <div
        v-else
        class="list-group"
      >
        <div v-if="textFilter.length > 2 && searchResult.length < 1">
          <div class="alert alert-info my-4">
            {{ $t('sectorSelectionModal.axtarSznUyunNticTaplmad') }}
          </div>
        </div>

        <SectorSelectionSectorItem
          v-for="s in searchResult"
          :key="s.id"
          :sector="s"
          :max-selection="maxSelection"
          :selected-ids="selectedIds"
          :selected-parent-ids="selectedParentIds"
          @selected="sectorSelected($event)"
          @removed="sectorRemoved($event)"
        />
      </div>
    </div>

    <div
      class="p-3"
      style="position: absolute; bottom: 0; left: 0; right: 0; background: #fff;"
    >
      <button
        type="button"
        class="btn btn-success"
        @click.prevent="$emit('done', selectedSectors)"
      >
        {{ $t('sectorSelectionModal.yaddaSaxla') }}
      </button>
    </div>
  </div>
</template>

<script>
import { getWorkingSectors, searchWorkingSector } from "@/repositories/GeneralDataRepository";
import SectorSelectionSectorItem from "@/components/SectorSelectionSectorItem.vue";

export default {
  name: "SectorSelectionModal",
  components: { SectorSelectionSectorItem },
  props: {
    errorTitle:{
      default(){
        return null;
      }
    },
    parentSector: {
      default() {
        return null;
      }
    },
    maxSelection: {
      default() {
        return 3;
      }
    },
    maxParentSelection: {
      default() {
        return 10000;
      }
    },
    selected: {
      default() {
        return [];
      }
    }
  },
  emits: ["done"],
  data() {
    return {

      parent: null,
      activeSectors: [],
      sectors: [],
      selectedSectors: [],
      selectedIds: [],
      selectedParentIds: [],
      textFilter: '',
      searchResult: [],
      sectorMap: []
    };
  },
  watch: {
    sectors: {
      deep: true,
      handler() {
        this.sectorMap = this.createSectorMap(0);
      }
    },
    parent: {
      deep: true,
      handler() {
        this.sectorMap = this.createSectorMap(0);
      }
    },
    textFilter: {
      deep: true,
      handler() {
        searchWorkingSector(this.textFilter).then((list) => {
          this.searchResult = list;
        });
      }
    },
    selectedSectors: {
      deep: true,
      handler() {
        this.buildParentSectorList();
      }
    }
  },
  mounted() {
    getWorkingSectors(this.$i18n.locale).then(data => {
      this.sectors = data;
      this.sectorMap = this.createSectorMap(0);
    });

    this.parent = this.parentSector;
    this.selectedSectors = [...this.selected];

    this.selected.forEach(s => {
      this.selectedIds.push(s.id);
    });
  },
  methods: {
    createSectorMap(parentId) {
      return this.sectors.filter(s => {
        if (parentId < 1) {
          if (s.parent === null) {
            s.children = this.createSectorMap(s.id);
            return true;
          }
        } else {
          if (s.parent && s.parent.id === parentId) {
            s.children = this.createSectorMap(s.id);
            return true;
          }
        }
        return false;
      });
    },

    sectorSelected(sector) {
      const parentSectors = this.getUniqueParentSectors(this.selectedSectors);

      if (this.selectedIds.indexOf(sector.id) < 0) {
        if (this.selectedSectors.length < this.maxSelection) {
          if (parentSectors.length < this.maxParentSelection || parentSectors.includes(sector.parent)) {
            this.selectedSectors.push(sector);
            this.selectedIds.push(sector.id);
          }else if (parentSectors.length >= this.maxParentSelection) {
            this.$swal({
              title: this.$t("generalModal.warningTitle"),
              text: 'Maximum icaze verilen say : ' + this.maxParentSelection,
              icon: 'warning',
            })
          }
        }
      }
    },
    sectorRemoved(sector) {
      if (this.selectedIds.indexOf(sector.id) > -1) {
        this.selectedSectors = this.selectedSectors.filter(s => s.id !== sector.id);
        this.selectedIds = this.selectedIds.filter(s => s !== sector.id);
      }
    },

    buildSectorIdPath(sector) {
      let list = [];

      if (sector.parent !== null) {
        list = this.buildSectorIdPath(sector.parent);
      }
      list.push(sector.id);

      return list;
    },

    buildParentSectorList() {
      let list = [];
      this.selectedSectors.forEach(s => {
        list = [
          ...list,
          ...this.buildSectorIdPath(s)
        ];
      });
      this.selectedParentIds = list;
    },

    getUniqueParentSectors(sectors) {
      const parents = new Set();
      sectors.forEach(sector => {
        if (sector.parent) {
          parents.add(sector.parent.id);
        }
      });
      return Array.from(parents);
    }
  }
};
</script>

<style scoped>
/* Your styles here */
</style>
